<template>
    <cr-text-field v-model="model" required :label="t('CHALLENGE_FORM_FLAG_LABEL')"></cr-text-field>
</template>

<style scoped>
:deep(input),
:deep(label)::after
{
    background-color: transparent !important;
}
:deep(label)::before
{
    content: none !important;
}
.cr-text-field,
.cr-text-field :deep(input)
{
    font-size: var(--cr-input-text-size);
}
</style>

<script setup lang="ts">
import { IChallenge } from '@cyber-range/cyber-range-api-ctf-challenge-client';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = defineProps<{
    challenge: IChallenge; 
    disabled?: boolean; 
}>();

const model = defineModel<string>();
</script>
